/**
 * Product compare — bootstrap (global listeners and store export).
 * Load after core, toast, dock, and table modules.
 */
(function () {
	'use strict';

	const productCompare = window.ProductCompare;

	if (!productCompare?.store) {
		return;
	}

	const { CHANGE_EVENT: compareChangeEvent, store: productCompareStore, syncCompareToggleButtons, onCompareToggleClick } = productCompare;

	if (productCompare.isBootstrapComplete) {
		return;
	}

	productCompare.isBootstrapComplete = true;

	document.addEventListener('click', onCompareToggleClick);
	document.addEventListener(compareChangeEvent, syncCompareToggleButtons);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', syncCompareToggleButtons);
	} else {
		syncCompareToggleButtons();
	}

	window.ProductCompareStore = productCompareStore;
})();
